/**
 * Web component: disponibilità per location + prenotazione in negozio (webhook Make).
 */
(function () {
  'use strict';

  var TAG = 'store-inventory-locations';

  var inflightRequests = new Map();

  function debounce(fn, ms) {
    var t;
    return function () {
      var ctx = this;
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, ms);
    };
  }

  function normalizeLocations(payload) {
    if (!payload) return [];
    var raw = Array.isArray(payload) ? payload : payload.locations || payload.data || payload.results;
    if (!Array.isArray(raw)) return [];

    return raw.map(function (row, i) {
      if (!row || typeof row !== 'object') return null;
      var name =
        row.name ||
        row.location ||
        row.location_name ||
        row.title ||
        row.store ||
        row.label ||
        'Location ' + (i + 1);
      var address =
        row.address != null && String(row.address).trim() !== '' ? String(row.address).trim() : '';
      var qty =
        row.quantity != null
          ? row.quantity
          : row.available != null
            ? row.available
            : row.inventory_quantity != null
              ? row.inventory_quantity
              : row.qty;
      var locIdRaw =
        row.locationid != null
          ? row.locationid
          : row.location_id != null
            ? row.location_id
            : row.locationId != null
              ? row.locationId
              : row.id;
      var locationId =
        locIdRaw != null && String(locIdRaw).trim() !== ''
          ? String(locIdRaw).trim()
          : '';
      return { name: String(name), address: address, quantity: qty, locationId: locationId };
    }).filter(Boolean);
  }

  function filterLocationsByMinQuantity(locations, minQty) {
    if (!Array.isArray(locations) || !minQty || minQty < 1) return locations || [];
    return locations.filter(function (loc) {
      var q = loc.quantity;
      var n = q == null || q === '' ? NaN : Number(q);
      if (!Number.isFinite(n)) n = 0;
      return n >= minQty;
    });
  }

  class StoreInventoryLocations extends HTMLElement {
    constructor() {
      super();
      this._debouncedFetch = debounce(this._fetchNow.bind(this), 200);
      this._onVariantChange = this._onVariantChange.bind(this);
      this._onSelectChange = this._onSelectChange.bind(this);
      this._onListClick = this._onListClick.bind(this);
      this._onListKeydown = this._onListKeydown.bind(this);
      this._onReserveCtaClick = this._onReserveCtaClick.bind(this);
      this._onDialogCloseClick = this._onDialogCloseClick.bind(this);
      this._onDialogBackdropClick = this._onDialogBackdropClick.bind(this);
      this._onReserveFormSubmit = this._onReserveFormSubmit.bind(this);
      this._onReserveFieldInput = this._onReserveFieldInput.bind(this);
      this._onAccordionToggle = this._onAccordionToggle.bind(this);
      this._$productTemplate = null;
      this._selectedLocation = null;
      this._reserveHandlersBound = false;
      this._accordion = null;
      this._renderedKey = null;
    }

    static get observedAttributes() {
      return [
        'variant-id',
        'variant-sku',
        'endpoint',
        'method',
        'shop',
        'product-id',
        'reserve-endpoint',
        'data-reserve-endpoint',
        'reserve-enabled',
      ];
    }

    connectedCallback() {
      this._ensureShell();
      this._syncReserveLabels();
      this._syncVariantHiddenInputs();
      this._setupReserveHandlers();
      this._attachListeners();
      this._requestFetch();
    }

    disconnectedCallback() {
      this._detachListeners();
    }

    attributeChangedCallback(name, oldVal, newVal) {
      if (oldVal === newVal) return;
      if (name === 'variant-id' || name === 'endpoint' || name === 'method') {
        this._clearLocationSelection();
        this._renderedKey = null;
        this._requestFetch();
      }
      if (name === 'reserve-endpoint' || name === 'data-reserve-endpoint' || name === 'reserve-enabled') {
        this._syncReserveLabels();
      }
    }

    _reserveEnabled() {
      return (this.getAttribute('reserve-enabled') || '').toLowerCase() !== 'false';
    }

    _getProductJsonScript() {
      var tpl = document.querySelector('.product-template');
      if (!tpl) return null;
      return tpl.querySelector('script[type="application/json"][id^="ProductJson-"]');
    }

    _skuForVariantId(variantId) {
      if (variantId == null || variantId === '') return '';
      var script = this._getProductJsonScript();
      if (!script || !script.textContent) return '';
      try {
        var product = JSON.parse(script.textContent);
        var vid = String(variantId);
        var variants = product.variants || [];
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === vid) {
            return variants[i].sku != null ? String(variants[i].sku) : '';
          }
        }
      } catch (err) {
        /* ignore */
      }
      return '';
    }

    _syncVariantHiddenInputs() {
      var d = this._dialogEls();
      var form = d.form;
      if (!form) return;
      var vid = (this.getAttribute('variant-id') || '').trim();
      var sku = (this.getAttribute('variant-sku') || '').trim();
      var vi = form.querySelector('input[name="variant_id"]');
      var vs = form.querySelector('input[name="variant_sku"]');
      if (vi) vi.value = vid;
      if (vs) vs.value = sku;
    }

    _reserveWebhookUrl() {
      return (
        this.getAttribute('data-reserve-endpoint') ||
        this.getAttribute('reserve-endpoint') ||
        ''
      ).trim();
    }

    _ensureShell() {
      if (this.querySelector('[data-root]')) return;
      this.innerHTML = '';
      var root = document.createElement('div');
      root.setAttribute('data-root', '');
      root.className = 'store-inventory-locations__inner';
      root.innerHTML =
        '<p class="store-inventory-locations__status store-inventory-locations__status--loading" data-loading hidden></p>' +
        '<p class="store-inventory-locations__status store-inventory-locations__status--error" data-error hidden role="alert"></p>' +
        '<div class="store-inventory-locations__list-panel" data-list-panel hidden>' +
        '<div class="store-inventory-locations__list-header">' +
        '<span class="store-inventory-locations__list-header__location" data-list-h-loc></span>' +
        '<span class="store-inventory-locations__list-header__qty" data-list-h-qty></span>' +
        '</div>' +
        '<ul class="store-inventory-locations__list" data-list></ul>' +
        '</div>' +
        '<p class="store-inventory-locations__status store-inventory-locations__status--empty" data-empty hidden></p>' +
        '<div class="store-inventory-locations__actions" data-reserve-actions hidden>' +
        '<button type="button" class="store-inventory-locations__reserve-cta"></button>' +
        '</div>' +
        '<dialog class="store-inventory-locations__dialog" aria-modal="true">' +
        '<div class="store-inventory-locations__dialog-panel">' +
        '<div class="store-inventory-locations__dialog-head">' +
        '<h3 class="store-inventory-locations__dialog-title" data-dialog-title></h3>' +
        '<button type="button" class="store-inventory-locations__dialog-x" data-dialog-close aria-label="Close">&times;</button>' +
        '</div>' +
        '<p class="store-inventory-locations__dialog-store" data-dialog-store hidden></p>' +
        '<p class="store-inventory-locations__dialog-store-address" data-dialog-store-address hidden></p>' +
        '<form class="store-inventory-locations__reserve-form" data-reserve-form novalidate>' +
        '<input type="hidden" name="location_id" value="" />' +
        '<input type="hidden" name="variant_id" value="" />' +
        '<input type="hidden" name="variant_sku" value="" />' +
        '<div class="store-inventory-locations__form-fields" data-reserve-form-fields>' +
        '<label class="store-inventory-locations__field" data-field="first_name">' +
        '<span class="store-inventory-locations__field-label" data-lbl="first"></span>' +
        '<input type="text" name="first_name" autocomplete="given-name" />' +
        '<span class="store-inventory-locations__field-msg" data-field-error hidden role="alert"></span>' +
        '</label>' +
        '<label class="store-inventory-locations__field" data-field="last_name">' +
        '<span class="store-inventory-locations__field-label" data-lbl="last"></span>' +
        '<input type="text" name="last_name" autocomplete="family-name" />' +
        '<span class="store-inventory-locations__field-msg" data-field-error hidden role="alert"></span>' +
        '</label>' +
        '<label class="store-inventory-locations__field" data-field="email">' +
        '<span class="store-inventory-locations__field-label" data-lbl="email"></span>' +
        '<input type="email" name="email" autocomplete="email" inputmode="email" />' +
        '<span class="store-inventory-locations__field-msg" data-field-error hidden role="alert"></span>' +
        '</label>' +
        '<label class="store-inventory-locations__field" data-field="phone">' +
        '<span class="store-inventory-locations__field-label" data-lbl="phone"></span>' +
        '<input type="tel" name="phone" autocomplete="tel" inputmode="tel" />' +
        '<span class="store-inventory-locations__field-msg" data-field-error hidden role="alert"></span>' +
        '</label>' +
        '<div class="store-inventory-locations__dialog-actions">' +
        '<button type="submit" class="store-inventory-locations__reserve-submit"></button>' +
        '</div>' +
        '</div>' +
        '<p class="store-inventory-locations__reserve-feedback" data-reserve-feedback hidden role="status"></p>' +
        '</form>' +
        '</div>' +
        '</dialog>';
      this.appendChild(root);
    }

    _dialogEls() {
      var root = this.querySelector('[data-root]');
      if (!root) return {};
      return {
        dialog: root.querySelector('.store-inventory-locations__dialog'),
        title: root.querySelector('[data-dialog-title]'),
        storeName: root.querySelector('[data-dialog-store]'),
        storeAddress: root.querySelector('[data-dialog-store-address]'),
        form: root.querySelector('[data-reserve-form]'),
        feedback: root.querySelector('[data-reserve-feedback]'),
        formFields: root.querySelector('[data-reserve-form-fields]'),
        submitBtn: root.querySelector('.store-inventory-locations__reserve-submit'),
        closeBtn: root.querySelector('[data-dialog-close]'),
        reserveCta: root.querySelector('.store-inventory-locations__reserve-cta'),
        actions: root.querySelector('[data-reserve-actions]'),
        list: root.querySelector('[data-list]'),
      };
    }

    _syncReserveLabels() {
      var d = this._dialogEls();
      if (d.reserveCta) {
        d.reserveCta.textContent =
          this.getAttribute('data-reserve-cta') || 'Reserve in this store';
      }
      if (d.submitBtn) {
        d.submitBtn.textContent =
          this.getAttribute('data-reserve-submit') || 'Send request';
      }
      if (d.closeBtn) {
        d.closeBtn.setAttribute(
          'aria-label',
          this.getAttribute('data-dialog-close-label') || 'Close'
        );
      }
      if (d.title) {
        d.title.textContent =
          this.getAttribute('data-reserve-modal-title') || 'Reserve in store';
      }
      var root = this.querySelector('[data-root]');
      if (!root) return;
      var self = this;
      [
        { sel: '[data-lbl="first"]', attr: 'data-lbl-first', def: 'First name' },
        { sel: '[data-lbl="last"]', attr: 'data-lbl-last', def: 'Last name' },
        { sel: '[data-lbl="email"]', attr: 'data-lbl-email', def: 'Email' },
        { sel: '[data-lbl="phone"]', attr: 'data-lbl-phone', def: 'Phone' },
      ].forEach(function (L) {
        var el = root.querySelector(L.sel);
        if (el) el.textContent = self.getAttribute(L.attr) || L.def;
      });
      var hLoc = root.querySelector('[data-list-h-loc]');
      var hQty = root.querySelector('[data-list-h-qty]');
      if (hLoc) {
        hLoc.textContent =
          self.getAttribute('data-list-header-location') || 'Store';
      }
      if (hQty) {
        hQty.textContent = self.getAttribute('data-list-header-qty') || 'Available';
      }
    }

    _setupReserveHandlers() {
      if (this._reserveHandlersBound) return;
      var d = this._dialogEls();
      if (d.list) {
        d.list.addEventListener('click', this._onListClick);
        d.list.addEventListener('keydown', this._onListKeydown);
      }
      if (d.reserveCta) {
        d.reserveCta.addEventListener('click', this._onReserveCtaClick);
      }
      if (d.closeBtn) {
        d.closeBtn.addEventListener('click', this._onDialogCloseClick);
      }
      if (d.dialog) {
        d.dialog.addEventListener('click', this._onDialogBackdropClick);
      }
      if (d.form) {
        d.form.addEventListener('submit', this._onReserveFormSubmit);
        d.form.addEventListener('input', this._onReserveFieldInput);
      }
      this._reserveHandlersBound = true;
    }

    _clearReserveFieldErrors(form) {
      if (!form) return;
      form.querySelectorAll('.store-inventory-locations__field').forEach(function (wrap) {
        wrap.classList.remove('store-inventory-locations__field--invalid');
        var err = wrap.querySelector('[data-field-error]');
        if (err) {
          err.hidden = true;
          err.textContent = '';
        }
      });
    }

    _setReserveFieldError(form, fieldKey, message) {
      var wrap = form.querySelector('[data-field="' + fieldKey + '"]');
      if (!wrap) return;
      wrap.classList.add('store-inventory-locations__field--invalid');
      var err = wrap.querySelector('[data-field-error]');
      if (err) {
        err.textContent = message;
        err.hidden = false;
      }
    }

    _onReserveFieldInput(ev) {
      var input = ev.target;
      if (!input || !input.closest || !input.closest('[data-reserve-form]')) return;
      if (input.tagName !== 'INPUT') return;
      var wrap = input.closest('.store-inventory-locations__field');
      if (!wrap) return;
      wrap.classList.remove('store-inventory-locations__field--invalid');
      var err = wrap.querySelector('[data-field-error]');
      if (err) {
        err.hidden = true;
        err.textContent = '';
      }
    }

    _emailLooksValid(s) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(s).trim());
    }

    _validateReserveForm(form) {
      this._clearReserveFieldErrors(form);
      var ok = true;
      var self = this;
      var fd = new FormData(form);
      var first = (fd.get('first_name') || '').toString().trim();
      var last = (fd.get('last_name') || '').toString().trim();
      var email = (fd.get('email') || '').toString().trim();
      var phone = (fd.get('phone') || '').toString().trim();

      if (!first) {
        self._setReserveFieldError(
          form,
          'first_name',
          self.getAttribute('data-val-first') || 'Please enter your first name.'
        );
        ok = false;
      }
      if (!last) {
        self._setReserveFieldError(
          form,
          'last_name',
          self.getAttribute('data-val-last') || 'Please enter your last name.'
        );
        ok = false;
      }
      if (!email) {
        self._setReserveFieldError(
          form,
          'email',
          self.getAttribute('data-val-email') || 'Please enter your email address.'
        );
        ok = false;
      } else if (!self._emailLooksValid(email)) {
        self._setReserveFieldError(
          form,
          'email',
          self.getAttribute('data-val-email-format') || 'Please enter a valid email address.'
        );
        ok = false;
      }
      if (!phone) {
        self._setReserveFieldError(
          form,
          'phone',
          self.getAttribute('data-val-phone') || 'Please enter your phone number.'
        );
        ok = false;
      }

      if (!ok) {
        var firstBad = form.querySelector('.store-inventory-locations__field--invalid input');
        if (firstBad) firstBad.focus();
      }
      return ok;
    }

    _onListClick(ev) {
      if (!this._reserveEnabled()) return;
      var li = ev.target.closest('.store-inventory-locations__item');
      if (!li || !this._dialogEls().list.contains(li)) return;
      this._selectLocationItem(li);
    }

    _onListKeydown(ev) {
      if (!this._reserveEnabled()) return;
      if (ev.key !== 'Enter' && ev.key !== ' ') return;
      var li = ev.target.closest('.store-inventory-locations__item');
      if (!li) return;
      ev.preventDefault();
      this._selectLocationItem(li);
    }

    _selectLocationItem(li) {
      var list = this._dialogEls().list;
      if (!list) return;
      list.querySelectorAll('.store-inventory-locations__item').forEach(function (node) {
        node.classList.remove('store-inventory-locations__item--selected');
        node.setAttribute('aria-selected', 'false');
      });
      li.classList.add('store-inventory-locations__item--selected');
      li.setAttribute('aria-selected', 'true');
      this._selectedLocation = {
        name: li.getAttribute('data-loc-name') || '',
        address: li.getAttribute('data-loc-address') || '',
        quantity: li.getAttribute('data-loc-qty') || '',
        locationId: li.getAttribute('data-loc-id') || '',
      };
      var actions = this._dialogEls().actions;
      if (actions) actions.hidden = !this._reserveEnabled();
    }

    _clearLocationSelection() {
      this._selectedLocation = null;
      var list = this._dialogEls().list;
      if (list) {
        list.querySelectorAll('.store-inventory-locations__item').forEach(function (node) {
          node.classList.remove('store-inventory-locations__item--selected');
          node.setAttribute('aria-selected', 'false');
        });
      }
      var actions = this._dialogEls().actions;
      if (actions) actions.hidden = true;
    }

    _onReserveCtaClick() {
      if (!this._selectedLocation) return;
      var d = this._dialogEls();
      if (d.storeName) {
        d.storeName.textContent = this._selectedLocation.name;
        d.storeName.hidden = false;
      }
      if (d.storeAddress) {
        if (this._selectedLocation.address) {
          d.storeAddress.textContent = this._selectedLocation.address;
          d.storeAddress.hidden = false;
        } else {
          d.storeAddress.textContent = '';
          d.storeAddress.hidden = true;
        }
      }
      if (d.feedback) {
        d.feedback.setAttribute('hidden', '');
        d.feedback.textContent = '';
        d.feedback.className = 'store-inventory-locations__reserve-feedback';
      }
      if (d.form) {
        this._clearReserveFieldErrors(d.form);
        d.form.reset();
        d.form.classList.remove('store-inventory-locations__reserve-form--success-sent');
        var locIdInput = d.form.querySelector('input[name="location_id"]');
        if (locIdInput) locIdInput.value = this._selectedLocation.locationId || '';
        d.form.hidden = false;
        this._syncVariantHiddenInputs();
      }
      if (d.formFields) {
        d.formFields.removeAttribute('hidden');
      }
      if (d.submitBtn) d.submitBtn.disabled = false;
      if (d.dialog) {
        if (typeof d.dialog.showModal === 'function') {
          d.dialog.showModal();
        } else {
          d.dialog.setAttribute('open', '');
          document.body.classList.add('store-inventory-locations--dialog-open');
        }
        var first = d.form && d.form.querySelector('input[name="first_name"]');
        if (first) setTimeout(function () { first.focus(); }, 50);
      }
    }

    _closeDialog() {
      var d = this._dialogEls();
      if (!d.dialog) return;
      document.body.classList.remove('store-inventory-locations--dialog-open');
      if (typeof d.dialog.close === 'function' && d.dialog.open) {
        d.dialog.close();
      } else {
        d.dialog.removeAttribute('open');
      }
    }

    _onDialogCloseClick() {
      this._closeDialog();
    }

    _onDialogBackdropClick(ev) {
      if (ev.target === this._dialogEls().dialog) {
        this._closeDialog();
      }
    }

    _onReserveFormSubmit(ev) {
      ev.preventDefault();
      var d = this._dialogEls();
      var form = d.form;
      if (!form) return;
      if (!this._validateReserveForm(form)) return;

      var endpoint = this._reserveWebhookUrl();
      if (!endpoint) {
        if (d.feedback) {
          d.feedback.textContent =
            this.getAttribute('data-reserve-no-url') ||
            'Reservation is not configured.';
          d.feedback.classList.add('store-inventory-locations__reserve-feedback--error');
          d.feedback.hidden = false;
        }
        return;
      }

      var fd = new FormData(form);
      var variantIdRaw = (fd.get('variant_id') || this.getAttribute('variant-id') || '').toString().trim();
      var variantSku = (fd.get('variant_sku') || '').toString().trim();
      var productId = this.getAttribute('product-id') || '';
      var shop = this.getAttribute('shop') || '';
      var bodyObj = {
        shop: shop,
        product_id: productId ? Number(productId) || productId : null,
        variant_id: Number(variantIdRaw) || variantIdRaw,
        variant_sku: variantSku,
        product_title: this.getAttribute('data-product-title') || '',
        location_name: this._selectedLocation ? this._selectedLocation.name : '',
        location_address: this._selectedLocation ? this._selectedLocation.address : '',
        location_quantity: this._selectedLocation ? this._selectedLocation.quantity : '',
        location_id: (fd.get('location_id') || '').toString().trim(),
        first_name: (fd.get('first_name') || '').toString().trim(),
        last_name: (fd.get('last_name') || '').toString().trim(),
        email: (fd.get('email') || '').toString().trim(),
        phone: (fd.get('phone') || '').toString().trim(),
      };

      var headers = { Accept: 'application/json', 'Content-Type': 'application/json' };
      var headerName = this.getAttribute('data-header-name');
      var headerValue = this.getAttribute('data-header-value');
      if (headerName && headerValue) {
        headers[headerName] = headerValue;
      }

      if (d.submitBtn) d.submitBtn.disabled = true;
      if (d.feedback) {
        d.feedback.hidden = true;
        d.feedback.className = 'store-inventory-locations__reserve-feedback';
      }

      fetch(endpoint, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyObj),
        credentials: 'omit',
      })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text().then(function (t) {
            if (!t || !t.trim()) return {};
            try {
              return JSON.parse(t);
            } catch (e) {
              return {};
            }
          });
        })
        .then(
          function () {
            var ui = this._dialogEls();
            if (ui.formFields) {
              ui.formFields.setAttribute('hidden', '');
            }
            if (ui.form) {
              ui.form.classList.add('store-inventory-locations__reserve-form--success-sent');
            }
            if (ui.feedback) {
              ui.feedback.textContent =
                this.getAttribute('data-reserve-success') ||
                'Request sent. We will contact you soon.';
              ui.feedback.className =
                'store-inventory-locations__reserve-feedback store-inventory-locations__reserve-feedback--success';
              ui.feedback.removeAttribute('hidden');
            }
          }.bind(this)
        )
        .catch(
          function () {
            if (d.feedback) {
              d.feedback.textContent =
                this.getAttribute('data-reserve-error') ||
                'Could not send the request. Try again later.';
              d.feedback.classList.add('store-inventory-locations__reserve-feedback--error');
              d.feedback.hidden = false;
            }
            if (d.submitBtn) d.submitBtn.disabled = false;
          }.bind(this)
        );
    }

    _attachListeners() {
      this._accordion = this.closest('details');
      if (this._accordion) {
        this._accordion.addEventListener('toggle', this._onAccordionToggle);
      }
      this._$productTemplate = document.querySelector('.product-template');
      if (this._$productTemplate && window.jQuery) {
        window.jQuery(this._$productTemplate).on('variantChange.storeInventoryLocations', this._onVariantChange);
      }
      var select = this._$productTemplate && this._$productTemplate.querySelector('select[name="id"]');
      if (select) {
        select.addEventListener('change', this._onSelectChange);
      }
    }

    _detachListeners() {
      if (this._accordion) {
        this._accordion.removeEventListener('toggle', this._onAccordionToggle);
        this._accordion = null;
      }
      if (this._$productTemplate && window.jQuery) {
        window.jQuery(this._$productTemplate).off('variantChange.storeInventoryLocations', this._onVariantChange);
      }
      var select = this._$productTemplate && this._$productTemplate.querySelector('select[name="id"]');
      if (select) {
        select.removeEventListener('change', this._onSelectChange);
      }
      this._$productTemplate = null;
    }

    _onVariantChange(e, extraVariant) {
      var v = (e && e.variant) || extraVariant;
      if (!v || v.id == null) {
        var select = document.querySelector('.product-template select[name="id"]');
        if (select && select.value) {
          this.setAttribute('variant-id', select.value);
          this.setAttribute('variant-sku', this._skuForVariantId(select.value));
          this._syncVariantHiddenInputs();
        }
        return;
      }
      this.setAttribute('variant-id', String(v.id));
      var sku =
        v.sku != null && String(v.sku).trim() !== ''
          ? String(v.sku).trim()
          : this._skuForVariantId(v.id);
      this.setAttribute('variant-sku', sku);
      this._syncVariantHiddenInputs();
    }

    _onSelectChange(ev) {
      var sel = ev.target;
      if (!sel || !sel.value) return;
      this.setAttribute('variant-id', sel.value);
      this.setAttribute('variant-sku', this._skuForVariantId(sel.value));
      this._syncVariantHiddenInputs();
    }

    _els() {
      var root = this.querySelector('[data-root]');
      if (!root) return {};
      return {
        loading: root.querySelector('[data-loading]'),
        error: root.querySelector('[data-error]'),
        list: root.querySelector('[data-list]'),
        listPanel: root.querySelector('[data-list-panel]'),
        empty: root.querySelector('[data-empty]'),
      };
    }

    _setVisible(els, key) {
      ['loading', 'error', 'list', 'empty'].forEach(function (k) {
        var el = k === 'list' ? els.listPanel || els.list : els[k];
        if (!el) return;
        el.hidden = k !== key;
      });
    }

    /**
     * L'accordion è chiuso di default: finché resta chiuso non si chiama Make.
     */
    _isAccordionOpen() {
      var details = this._accordion || this.closest('details');
      return !details || details.open === true;
    }

    /** Identifica una richiesta: cambia con variante, endpoint e metodo. */
    _requestKey() {
      return [
        (this.getAttribute('endpoint') || '').trim(),
        (this.getAttribute('method') || 'POST').toUpperCase(),
        (this.getAttribute('variant-id') || '').trim(),
      ].join('|');
    }

    _requestFetch() {
      if (!this._isAccordionOpen()) return;
      this._debouncedFetch();
    }

    /** All'apertura recupera solo se a schermo non c'è già la variante corrente. */
    _onAccordionToggle() {
      if (!this._isAccordionOpen()) return;
      if (this._renderedKey === this._requestKey()) return;
      this._debouncedFetch();
    }

    _fetchNow() {
      if (!this._isAccordionOpen()) return;
      var endpoint = (this.getAttribute('endpoint') || '').trim();
      var variantId = (this.getAttribute('variant-id') || '').trim();
      var key = this._requestKey();
      var els = this._els();
      this._clearLocationSelection();

      if (!endpoint) {
        if (els.error) {
          els.error.textContent = this.getAttribute('data-msg-no-endpoint') || 'Configure the inventory endpoint in the theme editor.';
          this._setVisible(els, 'error');
        }
        this._renderedKey = key;
        return;
      }

      if (!variantId) {
        if (els.empty) {
          els.empty.textContent = this.getAttribute('data-msg-no-variant') || 'Select a variant to see store availability.';
          this._setVisible(els, 'empty');
        }
        this._renderedKey = key;
        return;
      }

      if (els.loading) {
        els.loading.textContent = this.getAttribute('data-loading-text') || 'Loading…';
        this._setVisible(els, 'loading');
      }

      this._fetchLocations(key)
        .then(
          function (locations) {
            // Risposta obsoleta: nel frattempo sono cambiate variante o endpoint.
            if (key !== this._requestKey()) return;
            this._renderLocations(locations, this._els());
            this._renderedKey = key;
          }.bind(this)
        )
        .catch(
          function () {
            if (key !== this._requestKey()) return;
            var ui = this._els();
            if (ui.error) {
              ui.error.textContent =
                this.getAttribute('data-error-text') ||
                'Unable to load store availability. Please try again later.';
            }
            this._setVisible(ui, 'error');
            // _renderedKey non avanza: riaprendo l'accordion si ritenta.
          }.bind(this)
        );
    }

    /**
     * Una sola richiesta per chiave: se ancora in pending riutilizza la stessa
     * promise, e la risposta resta in cache per i cambi di taglia successivi.
     */
    _fetchLocations(key) {
      var pending = inflightRequests.get(key);
      if (pending) return pending;

      var endpoint = (this.getAttribute('endpoint') || '').trim();
      var variantId = (this.getAttribute('variant-id') || '').trim();
      var variantSku = (this.getAttribute('variant-sku') || '').trim();
      var method = (this.getAttribute('method') || 'POST').toUpperCase();
      var shop = this.getAttribute('shop') || '';
      var productId = this.getAttribute('product-id') || '';

      var headers = { Accept: 'application/json', 'Content-Type': 'application/json' };
      var headerName = this.getAttribute('data-header-name');
      var headerValue = this.getAttribute('data-header-value');
      if (headerName && headerValue) {
        headers[headerName] = headerValue;
      }

      var init = {
        method: method === 'GET' ? 'GET' : 'POST',
        headers: headers,
        credentials: 'omit',
      };

      if (init.method === 'POST') {
        init.body = JSON.stringify({
          shop: shop,
          product_id: productId ? Number(productId) || productId : null,
          variant_id: Number(variantId) || variantId,
          variant_sku: variantSku,
        });
      }

      var url = endpoint;
      if (init.method === 'GET') {
        var u = new URL(endpoint, window.location.origin);
        if (shop) u.searchParams.set('shop', shop);
        if (productId) u.searchParams.set('product_id', String(productId));
        u.searchParams.set('variant_id', String(variantId));
        if (variantSku) u.searchParams.set('variant_sku', variantSku);
        url = u.toString();
      }

      var request = fetch(url, init)
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text().then(function (text) {
            try {
              return JSON.parse(text);
            } catch (e) {
              throw new Error('Invalid JSON');
            }
          });
        })
        .then(function (data) {
          return normalizeLocations(data);
        })
        .finally(function () {
          inflightRequests.delete(key);
        });

      inflightRequests.set(key, request);
      return request;
    }

    /**
     * Disegna la lista dalle location normalizzate. Filtro quantità minima ed
     * etichette si applicano qui, così un cambio da theme editor ridisegna
     * dalla cache senza richiamare Make.
     */
    _renderLocations(locations, els) {
      var minRaw = (this.getAttribute('data-min-display-qty') || '').trim();
      var minQty = parseInt(minRaw, 10);
      if (!Number.isFinite(minQty) || minQty < 0) minQty = 0;
      var visible = filterLocationsByMinQuantity(locations, minQty);

      if (!visible.length) {
        if (els.empty) {
          els.empty.textContent =
            this.getAttribute('data-empty-text') || 'No store availability for this variant.';
        }
        this._setVisible(els, 'empty');
        return;
      }
      if (!els.list) return;

      var reserveOn = this._reserveEnabled();
      var self = this;
      var qtyHeader = (
        self.getAttribute('data-list-header-qty') || 'Available'
      ).trim();
      var lowStockThreshold = parseInt(
        (self.getAttribute('data-low-stock-threshold') || '').trim(),
        10
      );
      if (!Number.isFinite(lowStockThreshold)) lowStockThreshold = 2;
      var lowStockLabel = (
        self.getAttribute('data-low-stock-label') || 'Low stock'
      ).trim();
      els.list.innerHTML = visible
        .map(function (loc) {
          var qtyLabel = '';
          if (loc.quantity != null && loc.quantity !== '') {
            var qStr = String(loc.quantity);
            var qNum = Number(loc.quantity);
            var isLowStock =
              Number.isFinite(qNum) && qNum > 0 && qNum <= lowStockThreshold;
            var lowStockHtml =
              isLowStock && lowStockLabel
                ? '<span class="store-inventory-locations__low-stock">' +
                  escapeHtml(lowStockLabel) +
                  '</span>'
                : '';
            var qtyAria =
              ' aria-label="' + escapeAttr(qtyHeader + ': ' + qStr) + '"';
            qtyLabel =
              '<div class="store-inventory-locations__qty-cell">' +
              lowStockHtml +
              '<span class="store-inventory-locations__qty"' +
              qtyAria +
              '>' +
              escapeHtml(qStr) +
              '</span></div>';
          }
          var addressHtml =
            loc.address
              ? '<span class="store-inventory-locations__address">' + escapeHtml(loc.address) + '</span>'
              : '';
          var attrs =
            ' class="store-inventory-locations__item"' +
            (reserveOn
              ? ' role="option" tabindex="0" aria-selected="false"'
              : '') +
            ' data-loc-name="' +
            escapeAttr(loc.name) +
            '" data-loc-address="' +
            escapeAttr(loc.address) +
            '" data-loc-qty="' +
            escapeAttr(loc.quantity == null ? '' : String(loc.quantity)) +
            '" data-loc-id="' +
            escapeAttr(loc.locationId || '') +
            '"';
          return (
            '<li' +
            attrs +
            '><div class="store-inventory-locations__meta">' +
            '<span class="store-inventory-locations__name">' +
            escapeHtml(loc.name) +
            '</span>' +
            addressHtml +
            '</div>' +
            qtyLabel +
            '</li>'
          );
        })
        .join('');
      this._setVisible(els, 'list');
      if (reserveOn) {
        els.list.setAttribute('role', 'listbox');
        els.list.setAttribute('aria-label', 'Store locations');
      } else {
        els.list.removeAttribute('role');
        els.list.removeAttribute('aria-label');
      }
    }
  }

  function escapeHtml(s) {
    return s
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;');
  }

  if (!customElements.get(TAG)) {
    customElements.define(TAG, StoreInventoryLocations);
  }
})();
